export const DXG_PUBLISHED_VERSION_BAGGAGE_NAME = 'deal360.publishedVersion';
